import * as Sentry from "@sentry/react";

let sentryInitialized = false;

function getSentryDsn(): string | undefined {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  return typeof dsn === "string" && dsn.trim() ? dsn.trim() : undefined;
}

export function initRuntimeMonitoring(): void {
  const dsn = getSentryDsn();
  if (!dsn || sentryInitialized) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
  });
  sentryInitialized = true;
}

export function logAppError(context: string, error: unknown, extra?: Record<string, unknown>): void {
  console.error(`[APP ERROR] ${context}`, error, extra ?? {});

  if (!sentryInitialized) return;

  Sentry.withScope((scope) => {
    if (extra) {
      Object.entries(extra).forEach(([key, value]) => scope.setExtra(key, value));
    }
    scope.setTag("context", context);
    Sentry.captureException(error instanceof Error ? error : new Error(String(error)));
  });
}

export function logAppWarning(context: string, extra?: Record<string, unknown>): void {
  console.warn(`[APP WARNING] ${context}`, extra ?? {});

  if (!sentryInitialized) return;

  Sentry.withScope((scope) => {
    if (extra) {
      Object.entries(extra).forEach(([key, value]) => scope.setExtra(key, value));
    }
    scope.setLevel("warning");
    scope.setTag("context", context);
    Sentry.captureMessage(context);
  });
}
